import { Injectable } from '@angular/core';
import {TourService} from './tour.service';
import {Option} from '../model/option';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {OptionDetailComponent} from '../components/option-detail.component';

declare function addNoBodyScrollClass();
declare function removeNoBodyScrollClass();

@Injectable()
export class OptionDetailService {

  constructor(private tourService: TourService,
              private dialog: MatDialog) { }

    showOption(option: Option) {

      this.tourService.videoVisibilityChanged.emit(false);

      const config = new MatDialogConfig();
      config.role = 'dialog';
      config.data = option;
      config.disableClose = false;
      config.height = '100%';
      config.width = (window.innerWidth <= 765 ) ? '90%' : '600px';
      const dialogRef = this.dialog.open(OptionDetailComponent, config);

      addNoBodyScrollClass();
      dialogRef.afterClosed().subscribe(result => {
        removeNoBodyScrollClass();
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/option-detail.service.ts